module.exports = __webpack_public_path__ + "static/media/heatingInstructions260122.a1fd618c.webp";